import { render, staticRenderFns } from "./AutoDeliveryView.vue?vue&type=template&id=62da6474"
import script from "./AutoDeliveryView.ts?vue&type=script&lang=ts&external"
export * from "./AutoDeliveryView.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports